export default __webpack_public_path__ + "static/social_media_page_header-8cc353a71c7d6228b86377ff81081eb9.jpg";